module.exports = __webpack_public_path__ + "static/media/TA-Logo-white.2b89bb95.png";